import MiDialog from './MiDialog.vue'

export default MiDialog
